// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e337b81c","72":"eff3689d","477":"7e70be5f","627":"a1f38da2","663":"0f56c794","667":"b165eb50","777":"bbf341a0","803":"de66eec1","820":"dcf3e3cd"}[chunkId] + ".chunk.js";
};